<div class="px-2 sm:px-4 md:px-8 py-4 sm:py-6 max-w-7xl mx-auto">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" style="margin-bottom: 20px;">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px; flex-shrink: 0;">description</mat-icon>
      <div>
        <h1 class="ref-title" style="font-size: 1.4rem; font-weight: 700; color: #1f2937; margin: 0;">
          Lista de depósitos VES
          <span *ngIf="total > 0" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
            {{ total }} registros
          </span>
        </h1>
        <p style="font-size: 0.8rem; color: #6b7280; margin: 2px 0 0;">Historial de referencias enviadas</p>
      </div>
    </div>

    <button type="button" (click)="goToRecharge()"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      Nueva carga
    </button>
  </div>

  <!-- Badge mobile -->
  <span *ngIf="total > 0" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-3">
    {{ total }} registros
  </span>

  <!-- Loading -->
  <div *ngIf="loading" style="text-align: center; padding: 48px 20px;">
    <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
    <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando referencias...</p>
  </div>

  <ng-container *ngIf="!loading">

    <!-- Paginator -->
    <mat-paginator
      *ngIf="total > 0"
      [length]="total"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 20, 50]"
      [pageIndex]="page - 1"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Seleccionar pagina de referencias"
      style="margin-bottom: 12px;">
    </mat-paginator>

    <!-- Cards -->
    <div class="flex flex-col gap-3">
      <div *ngFor="let ref of referencias"
        style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);"
        [style.borderColor]="expandedCardId === ref.id ? '#1C593D' : '#e5e7eb'">

        <!-- Card header -->
        <div (click)="toggleCard(ref.id)"
          style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer;"
          [style.background]="expandedCardId === ref.id ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

          <!-- Icon -->
          <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
            [style.background]="ref.status === 'APPROVED' ? '#f0fdf4' : ref.status === 'REJECTED' ? '#fef2f2' : '#fffbeb'">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
              [style.color]="ref.status === 'APPROVED' ? '#16a34a' : ref.status === 'REJECTED' ? '#dc2626' : '#f59e0b'">
              {{ ref.status === 'APPROVED' ? 'check_circle' : ref.status === 'REJECTED' ? 'cancel' : 'schedule' }}
            </mat-icon>
          </div>

          <!-- Info -->
          <div style="flex: 1; min-width: 0;">
            <div style="font-weight: 700; font-size: 0.85rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              Ref: {{ ref.referencia }}
            </div>
            <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
              {{ ref.createdAt | date:'medium' }}
            </div>
            <div class="flex items-center gap-2 flex-wrap" style="margin-top: 4px;">
              <span style="font-weight: 700; font-size: 0.85rem; color: #1e5a3f;">
                Bs. {{ ref.monto | number:'1.2-2' }}
              </span>
              <span
                style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                [style.background]="getStatusBg(ref.status)">
                {{ getStatusLabel(ref.status) }}
              </span>
            </div>
          </div>

          <!-- Arrow -->
          <mat-icon
            style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;"
            [style.transform]="expandedCardId === ref.id ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card body (expanded) -->
        <div *ngIf="expandedCardId === ref.id" style="border-top: 1px solid #f3f4f6;">
          <div style="padding: 10px 14px 12px;" class="sm:pl-16">
            <div class="flex flex-wrap gap-3" style="margin-bottom: 2px;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Banco:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.banco }}</span>
              </div>
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Tipo:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.tipoCuenta }}</span>
              </div>
            </div>
            <div *ngIf="ref.titular" class="flex flex-wrap gap-x-4 gap-y-1" style="margin-top: 4px;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Titular:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.titular }}</span>
              </div>
            </div>
            <div class="flex flex-wrap gap-x-4 gap-y-1" style="margin-top: 4px;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Cuenta:</span>
                <span style="font-size: 0.78rem; font-weight: 600; color: #374151; font-family: monospace; word-break: break-all;">{{ ref.cuenta }}</span>
              </div>
            </div>
            <div *ngIf="ref.updatedAt" class="flex flex-wrap gap-x-4 gap-y-1" style="margin-top: 4px;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Actualizado:</span>
                <span style="font-size: 0.78rem; color: #374151;">{{ ref.updatedAt | date:'medium' }}</span>
              </div>
            </div>

            <!-- Motivo de rechazo -->
            <div *ngIf="ref.status === 'REJECTED' && ref.motivoRechazo"
              style="margin-top: 10px; display: flex; align-items: flex-start; gap: 8px; background: #fef2f2; padding: 10px 12px; border-radius: 10px; border: 1px solid #fecaca;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">error_outline</mat-icon>
              <span style="font-size: 0.8rem; font-weight: 600; color: #dc2626;">{{ ref.motivoRechazo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="referencias.length === 0"
      style="text-align: center; padding: 48px 20px;">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">description</mat-icon>
      <p style="font-size: 0.95rem; color: #6b7280; margin: 0 0 16px;">No tienes referencias registradas</p>
      <button type="button" (click)="goToRecharge()"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
        Cargar referencia
      </button>
    </div>

  </ng-container>
</div>
